export const distributorCompanyToAssistanceEmailMapping: Record<string, string> = {
  MERCER: 'service.retraitemercer@axa.fr',
  HENNER: 'retraitehenner.brh@axa.fr',
  GRASSAVOYE: 'retraitegrassavoye@axa.fr',
  S2H: 'service.retraites2h@axa.fr',
  AON: 'service.retraiteaon@axa.fr',
};
